module.exports = __webpack_public_path__ + "img/no-access.78c29026.png";